var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominoTrainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.542,413.966L325.577,33.43c-3.115-11.631-10.575-21.354-21.004-27.375-10.429-6.021-22.578-7.623-34.21-4.504L116.336,42.822c-11.632,3.117-21.354,10.577-27.376,21.006-6.02,10.429-7.619,22.578-4.503,34.209l101.964,380.536c5.272,19.679,23.184,33.421,43.558,33.421,3.925-.002,7.847-.522,11.658-1.543l154.026-41.271c11.631-3.114,21.353-10.574,27.376-21.004,6.02-10.43,7.619-22.579,4.503-34.21ZM359.992,220.307l-211.899,56.778-49.025-182.963c-2.071-7.73-1.007-15.803,2.994-22.732,4.001-6.93,10.461-11.887,18.189-13.957l154.027-41.272c2.561-.686,5.186-1.034,7.806-1.034,5.202,0,10.363,1.392,14.926,4.027,6.93,4.001,11.886,10.461,13.958,18.19l49.025,182.962ZM391.749,454.571l-154.026,41.27c-7.73,2.07-15.805,1.008-22.733-2.994-6.93-4.001-11.887-10.461-13.958-18.189l-49.025-182.961,211.899-56.778,49.025,182.962c4.275,15.955-5.229,32.414-21.183,36.69Z",
    fill: "#f8f8ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226.878,
    cy: 147.315,
    r: 22.902,
    transform: "translate(-36.562 85.877) rotate(-19.869)",
    fill: "#f8f8ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.898,
    cy: 360.119,
    r: 22.902,
    transform: "translate(-161.959 252.903) rotate(-38.228)",
    fill: "#f8f8ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominoTrainIcon);
export default __webpack_public_path__ + "static/media/DominoTrainIcon.6b8550c577c8975daf31762e7ff562d2.svg";
export { ForwardRef as ReactComponent };